import "./footer.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import flagBrazil from "../../imagens/flags/br.png"
import { useTranslation } from 'react-i18next';

function Footer() {
    const { t } = useTranslation();

    const locations = [
        {
            key: "brazil",
            flag: flagBrazil,
            altFlag: "Bandeira do Brasil",
            // COLOQUE AQUI O LINK QUE VOCÊ COPIOU DO GOOGLE MAPS (EMBED)
            mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.1975!2d-46.652!3d-23.564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDMzJzUxLjIiUyA0NsKwMzknMDguOSJX!5e0!3m2!1spt-BR!2sbr!4v1600000000000!5m2!1spt-BR!2sbr"
        },
        // Exemplo para quando descomentar os outros países:
        // {
        //     key: "usa",
        //     flag: flagEUA,
        //     altFlag: "Flag of United States",
        //     mapUrl: "https://www.google.com/maps/embed?pb=LINK_DO_MAPA_EUA..." 
        // },
    ];

    return (
        <div className="container-fluid p-0">
            <footer className="footer" id="footer">
                <div className="row align-items-center m-0 justify-content-around">

                    {/* DIREITOS - Manteve igual */}
                    <div className="p-0 col-md-6 col-sm-6 text-custom custom-color text-center mb-md-0">
                        <p className="m-0">
                            © {new Date().getFullYear()} SSA - {t('footer.rightsCompany')}
                        </p>
                        <p className="m-0">
                            {t('footer.allRightsReserved')}
                        </p>
                    </div>

                    {/* ENDEREÇOS */}
                    <div className="col-lg-6 d-flex justify-content-center align-items-center text-center p-0 pt-4">

                        {locations.map((loc) => (
                            <div key={loc.key} className="footer-location-wrapper">

                                {/* BLOCO ESQUERDO */}
                                <div className="footer-location-left">
                                    <div className="icon-and-flag">
                                        <FontAwesomeIcon
                                            icon={faLocationDot}
                                            className="custom-icon"
                                        />
                                        <img
                                            src={loc.flag}
                                            alt={loc.altFlag}
                                            className="flag-footer ms-2"
                                        />
                                    </div>

                                    <p className="size-test bgColorCustom text-center m-0">
                                        {t(`footer.locations.${loc.key}.company`)}
                                    </p>

                                    <div className="footer-address-wrapper my-3">
                                        <p className="footerAddress m-0 custom-size text-center">
                                            {t(`footer.locations.${loc.key}.addressLine1`)}<br />
                                            {t(`footer.locations.${loc.key}.addressLine2`)}
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-8 col-md-12 mb-4">
                                    <div className="mt-0">
                                        <iframe
                                            title="localizacao"
                                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14768.665356095653!2d-46.370035!3d-22.271688!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cc4dcff76da3e5%3A0x8e68c9f9abed01b0!2sSSA%20-%20Solu%C3%A7%C3%B5es%20em%20Sistemas%20Automotivos%20LTDA!5e0!3m2!1spt-BR!2sbr!4v1769541975647!5m2!1spt-BR!2sbr"
                                            width="100%"
                                            height="200"
                                            style={{ border: 0, borderRadius: "8px" }}
                                            allowFullScreen
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        ></iframe>
                                    </div>
                                </div>

                            </div>
                        ))}

                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;